import { ModalController } from "@theme/modal-controller";

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );

    if (!sessionStorage.getItem("localization_form_submitted")) {
      this.detectLocation();
    }
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
      sessionStorage.setItem("localization_form_submitted", "true");
    }
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (this.elements.button.getAttribute("aria-expanded") === "false").toString(),
    );
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
  async detectLocation() {
    try {
      const response = await fetch(
        window.Shopify.routes.root +
          "browsing_context_suggestions.json" +
          "?country[enabled]=true" +
          `&country[exclude]=${window.Shopify.country}` +
          "&language[enabled]=true" +
          `&language[exclude]=${window.Shopify.language}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.suggestions || data.suggestions.length === 0) return;

      const suggestion = data.suggestions[0];
      const suggestedCountry = suggestion.parts.country?.handle;
      const currentCountry =
        window.Theme?.localization?.country?.iso_code || window.Shopify.country;

      if (!suggestedCountry || suggestedCountry === currentCountry) return;

      // Only auto-redirect when reasonably confident in the detection.
      const confidence = suggestion.parts.country?.confidence ?? 0;
      if (confidence < 0.8) return;

      // Mark before submitting so we don't re-trigger after the redirect lands.
      sessionStorage.setItem("localization_form_submitted", "true");

      this.submitLocalizationForm(suggestedCountry);
    } catch (error) {
      console.error("Error fetching browsing context suggestions:", error);
    }
  }

  submitLocalizationForm(countryCode) {
    const form = document.createElement("form");
    form.action = `${window.Shopify.routes.root}localization`;
    form.method = "POST";
    form.hidden = true;

    const method = document.createElement("input");
    method.type = "hidden";
    method.name = "_method";
    method.value = "PUT";
    form.appendChild(method);

    const country = document.createElement("input");
    country.type = "hidden";
    country.name = "country_code";
    country.value = countryCode;
    form.appendChild(country);

    const returnTo = document.createElement("input");
    returnTo.type = "hidden";
    returnTo.name = "return_to";
    returnTo.value = window.location.pathname + window.location.search;
    form.appendChild(returnTo);

    document.body.appendChild(form);
    form.submit();
  }
}
customElements.define("localization-form", LocalizationForm);
